/**
 * TPM PUBLIC API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Consent } from './consent';


/**
 * The selected slot, held for the patient until ``reserved_until``.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface SlotReservation { 
    reservationId: number;
    reservedUntil: string;
    secondsLeft: number;
    beforeCancellationPeriod: boolean;
    cancellationPeriodInHours: number;
    consent: Consent | null;
}
export const SlotReservation_reservationId_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SlotReservation_reservedUntil_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SlotReservation_secondsLeft_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SlotReservation_beforeCancellationPeriod_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SlotReservation_cancellationPeriodInHours_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SlotReservation_consent_Validators: ValidatorFn[] =
    [  Validators.required, ];


